/**
 * Resolve this book's Discovery session without minting a second (#973).
 *
 * Left-nav used to treat a missing currentStory.discovery_session_id as
 * "this book has none" and POST ensure-discovery-session. That field is
 * often missing: GET /stories/:id did not return it, and a standalone
 * book's notebook is project-scoped (created with the project), not
 * story-scoped. The click then minted a blank story-scoped row named
 * "Discovery" beside the real notebook (often labeled with the project
 * name).
 */

export function bookDiscoverySessionId({
  currentStory = null,
  currentProject = null,
  stories = [],
} = {}) {
  if (currentStory?.discovery_session_id) return currentStory.discovery_session_id;

  const listed = Array.isArray(stories)
    ? stories.find((row) => row?.id && row.id === currentStory?.id)
    : null;
  if (listed?.discovery_session_id) return listed.discovery_session_id;

  // Standalone: the project's Discovery *is* this book's Discovery.
  if (currentProject?.discovery_session_id && !currentProject.is_series) {
    return currentProject.discovery_session_id;
  }

  if (!currentStory?.id && currentProject?.discovery_session_id) {
    return currentProject.discovery_session_id;
  }

  return null;
}

export async function openBookDiscovery({
  currentStory = null,
  currentProject = null,
  stories = [],
  navigate,
  setCurrentStory,
  ensureDiscoverySession,
} = {}) {
  const existing = bookDiscoverySessionId({ currentStory, currentProject, stories });
  if (existing) {
    navigate(`/chat/${existing}`);
    return { sessionId: existing, created: false };
  }

  if (currentStory?.id && ensureDiscoverySession) {
    const ensured = await ensureDiscoverySession(currentStory.id);
    const sessionId = ensured?.session_id || ensured?.id || null;
    if (sessionId) {
      if (currentStory && setCurrentStory) {
        setCurrentStory({ ...currentStory, discovery_session_id: sessionId });
      }
      navigate(`/chat/${sessionId}`);
    }
    return { sessionId, created: Boolean(ensured?.created) };
  }

  if (currentProject?.id) {
    navigate(`/projects/${currentProject.id}/discovery`);
    return { sessionId: null, created: false };
  }

  return { sessionId: null, created: false };
}
